import { Button, Pagination, Table } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BeatLoader from "react-spinners/BeatLoader";
import {
  getSrtUnsolicitedSamplesList,
  selectUnselectSrtTableRows,
  srtEXportArray,
  srtUnsolicitedEditData,
  unsolicitedMassFilter,
} from "../../../Redux/actions/Srt/Srt";
import EditIcon from "../../../images/edit-icon.png";
import RowSavedData from "../../SRF/TableComp.js/RowSavedData";
import UnsolicitedInput from "./UnsolicitedCommonComp/UnsolicitedInput.js/UnsolicitedInput";
import UnsolicitedReceivedDate from "./UnsolicitedCommonComp/UnsolicitedReceivedDate/UnsolicitedReceivedDate";
import UnsolicitedComment from "./UnsolicitedCommonComp/UnsolicitedComment/UnsolicitedComment";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader } from "../../../UIComponents/Loader";

const UnsolicitedTable = ({
  massFilterData,
  current,
  setCurrent,
  pageCount,
  setPageCount,
  totalPerPage, 
  chunkSize, 
  containerRef 
}) => {
  const dispatch = useDispatch();
  const [editingKey, setEditingKey] = useState("");
  // const containerRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [isChunkLoading, setIsChunkLoading] = useState(false);
  const [visibleCount, setVisibleCount] = useState(chunkSize);

  useEffect(() => {
  setVisibleCount(chunkSize);

  const scrollEl = containerRef?.containerRef?.containerRef?.current;

  if (scrollEl) {
      scrollEl.scrollTop = 0;
    }
  }, [current]);
  const updateQueryParams = (page, pageSize) => {
    const newQueryParams = new URLSearchParams(location.search);
    newQueryParams.set("page", page);
    newQueryParams.set("pageSize", pageSize);
    navigate({ search: newQueryParams.toString() }, { replace: true });
  };
  useEffect(() => {
    console.log("checkingpagenumber", current, pageCount);
  }, [current, pageCount]);

  const srtUnsolicitedListData = useSelector(
    (state) => state?.Srt?.srtUnsolicitedList
  );
  const massFilterApiData = useSelector(
    (state) => state?.Srt?.unsolicitedMassSearchFilterResult
  );
  const seasonFilterApiData = useSelector(
    (state) => state?.Srt?.seasonSearchFilterResult
  );
  const srtSearchLoader = useSelector((state) => state?.Srt?.searchLoader);
  const srtSeasonData = useSelector((state) => state?.Srt?.srtSeasonSearch);
  const selectedUnselectedRows = useSelector(
    (state) => state?.Srt?.srtSelectedTableRows
  );

  const [uncolicitedEditValues, setUnsolicitedEditValues] = useState({
    id: "",
    factory: "",
    COO: "",
    description: "",
    reference_number: "",
    color: "",
    size: "",
    date_received: "",
    qty_prs_received: "",
    comments: "",
  });

  // const updateQueryParams = (page, pageSize) => {
  //   const newQueryParams = new URLSearchParams(location.search);
  //   newQueryParams.set("page", page);
  //   newQueryParams.set("pageSize", pageSize);
  //   navigate({ search: newQueryParams.toString() }, { replace: true });
  // };

  // useEffect(() => {
  //   updateQueryParams(current, pageCount);
  // }, [current, pageCount]);

  const initialSearch = () => {
    if (massFilterApiData?.results) {
      if (massFilterApiData.results.length === 0) return [];
      return massFilterApiData.results;
    }
    if (srtSeasonData?.results) {
      if (srtSeasonData.results.length === 0) return [];
      return srtSeasonData.results;
    }
    if (srtUnsolicitedListData?.results) {
      if (srtUnsolicitedListData.results.length === 0) return [];
      return srtUnsolicitedListData.results;
    }
    return [];
  };

  const getTotalCount = () => {
    const apiResponses = [
      {
        type: "massFilter",
        data: massFilterApiData,
        timestamp: massFilterApiData?.timestamp,
      },
      {
        type: "seasonFilter",
        data: srtSeasonData,
        timestamp: srtSeasonData?.timestamp,
      },
      {
        type: "initialList",
        data: srtUnsolicitedListData,
        timestamp: srtUnsolicitedListData?.timestamp,
      },
    ].filter((res) => res.data?.count != null);

    if (apiResponses.length === 0) return 0;

    const sorted = [...apiResponses].sort(
      (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
    );

    return sorted[0].data.count;
  };

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    const pidArray = selectedRows.map(
      (item) => item.ReferenceNumber.props.children
    );
    dispatch(srtEXportArray(pidArray));
    dispatch(selectUnselectSrtTableRows(newSelectedRowKeys));
  };

  const editForGettingData = (record, key) => {
    setUnsolicitedEditValues({
      id: record.key,
      factory: record.Factory.props.children,
      COO: record.COO.props.children,
      description: record.Description.props.children,
      reference_number: record.ReferenceNumber.props.children,
      color: record.Color.props.children,
      size: record.Size.props.children,
      date_received: record.DateReceived.props.children,
      qty_prs_received: record.QtyPrsRequestedReceived.props.children,
      comments: record.Comments.props.children,
    });
    setEditingKey(key);
  };

  const cancelButton = () => {
    setEditingKey("");
  };

  const isEditing = (record) => record.key === editingKey;

  const onInputsEditsChange = (event) => {
    const { name, value } = event.target;
    if (name === "qty_prs_received" && !/^\d*$/.test(value)) return;
    setUnsolicitedEditValues((prev) => ({ ...prev, [name]: value }));
  };

  const onReceivedDateChange = (date, dateString) => {
    setUnsolicitedEditValues((prev) => ({
      ...prev,
      date_received: dateString,
    }));
  };

  const saveButton = () => {
    dispatch(srtUnsolicitedEditData(uncolicitedEditValues));
    setEditingKey("");
  };

  const columns = [
    {
      title: "Factory",
      dataIndex: "Factory",
      width: "10%",
      render: (text, record) =>
        isEditing(record) ? (
          <UnsolicitedInput
            value={uncolicitedEditValues.factory}
            name="factory"
            onchange={onInputsEditsChange}
          />
        ) : (
          <RowSavedData resData={record.Factory.props.children} />
        ),
    },
    {
      title: "COO",
      dataIndex: "COO",
      width: "10%",
      render: (text, record) =>
        isEditing(record) ? (
          <UnsolicitedInput
            value={uncolicitedEditValues.COO}
            name="COO"
            onchange={onInputsEditsChange}
          />
        ) : (
          <RowSavedData resData={record.COO.props.children} />
        ),
    },
    {
      title: "Description",
      dataIndex: "Description",
      width: "10%",
      render: (text, record) =>
        isEditing(record) ? (
          <UnsolicitedInput
            value={uncolicitedEditValues.description}
            name="description"
            onchange={onInputsEditsChange}
          />
        ) : (
          <RowSavedData resData={record.Description.props.children} />
        ),
    },
    {
      title: "Reference Number",
      dataIndex: "ReferenceNumber",
      width: "10%",
      render: (text, record) =>
        isEditing(record) ? (
          <UnsolicitedInput
            value={uncolicitedEditValues.reference_number}
            name="reference_number"
            onchange={onInputsEditsChange}
          />
        ) : (
          <RowSavedData resData={record.ReferenceNumber.props.children} />
        ),
    },
    {
      title: "Color",
      dataIndex: "Color",
      width: "10%",
      render: (text, record) =>
        isEditing(record) ? (
          <UnsolicitedInput
            value={uncolicitedEditValues.color}
            name="color"
            onchange={onInputsEditsChange}
          />
        ) : (
          <RowSavedData resData={record.Color.props.children} />
        ),
    },
    {
      title: "Size",
      dataIndex: "Size",
      width: "10%",
      render: (text, record) =>
        isEditing(record) ? (
          <UnsolicitedInput
            value={uncolicitedEditValues.size}
            name="size"
            onchange={onInputsEditsChange}
          />
        ) : (
          <RowSavedData resData={record.Size.props.children} />
        ),
    },
    {
      title: "Date Received",
      dataIndex: "DateReceived",
      width: "10%",
      render: (text, record) =>
        isEditing(record) ? (
          <UnsolicitedReceivedDate
            recievedDate={record.DateReceived.props.children}
            name="date_received"
            onDateChange={onReceivedDateChange}
          />
        ) : (
          <RowSavedData resData={record.DateReceived.props.children} />
        ),
    },
    {
      title: "Qty.Prs. Received",
      dataIndex: "QtyPrsRequestedReceived",
      width: "10%",
      render: (text, record) =>
        isEditing(record) ? (
          <UnsolicitedInput
            value={uncolicitedEditValues.qty_prs_received}
            name="qty_prs_received"
            onchange={onInputsEditsChange}
          />
        ) : (
          <RowSavedData
            resData={record.QtyPrsRequestedReceived.props.children}
          />
        ),
    },
    {
      title: "Comments",
      dataIndex: "Comments",
      width: "10%",
      render: (text, record) =>
        isEditing(record) ? (
          <UnsolicitedInput
            value={uncolicitedEditValues.comments}
            name="comments"
            onchange={onInputsEditsChange}
          />
        ) : (
          <UnsolicitedComment resData={record.Comments.props.children} />
        ),
    },
    {
      title: <p className="remove-color">hi</p>,
      dataIndex: "action",
      width: "7%",
      render: (_, record) =>
        isEditing(record) ? (
          <div>
            <Button className="srf-cancel" onClick={saveButton}>
              Save
            </Button>
            <Button className="srf-cancel" onClick={cancelButton}>
              Cancel
            </Button>
          </div>
        ) : (
          <div className="addbutton-and-edit-container">
            <img
              className="edit-row-img"
              src={EditIcon}
              onClick={() => editForGettingData(record, record.key)}
              alt="edit"
            />
          </div>
        ),
    },
  ];

  const rowSelection = {
    selectedRowKeys: selectedUnselectedRows,
    onChange: onSelectChange,
  };

  const data = [];
  {
    initialSearch()?.map((item, index) => {
      return data.push({
        key: item?.id,
        Factory: <p className="vendor-name">{item?.factory_name}</p>,
        COO: <span className="socks-id">{item?.COO}</span>,
        Description: <span className="socks-color">{item?.description}</span>,
        ReferenceNumber: (
          <span className="socks-size">{item?.reference_number}</span>
        ),
        Color: <span className="socks-color">{item?.color}</span>,
        Size: <span className="socks-size">{item?.size}</span>,
        DateReceived: (
          <span className="vendor-name">{item?.date_received}</span>
        ),
        QtyPrsRequestedReceived: (
          <span className="promised-ex-factory">{item?.qty_prs_received}</span>
        ),
        Comments: (
          <p
            className="vendor-name"
            style={{ width: "350px", margin: "0 auto" }}
          >
            {item?.comments}
          </p>
        ),
      });
    });
  }

  useEffect(() => {
  if (!containerRef?.containerRef?.containerRef?.current) return;
  
  const scrollEl = containerRef?.containerRef?.containerRef?.current;
  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } = scrollEl;

    const bottomReached =
    scrollTop + clientHeight >= scrollHeight - 5;

    if (bottomReached && visibleCount < data.length) {
      setIsChunkLoading(true);
      setTimeout(() => {
        setVisibleCount(prev =>
          Math.min(prev + chunkSize, data.length)
        );
        setIsChunkLoading(false);
      }, 400);
    }
  };

  scrollEl.addEventListener("scroll", handleScroll);

  return () =>
    scrollEl.removeEventListener("scroll", handleScroll);

}, [visibleCount, data.length, chunkSize, containerRef]);
  const [isPageChangeTriggered, setIsPageChangeTriggered] = useState(false);

  const isChangingPageSizeRef = useRef(false);

  const onChange = (page) => {
    if (isChangingPageSizeRef.current) {
      return;
    }

    setCurrent(page);
    updateQueryParams(page, pageCount);
    handlePaginationChange(page, pageCount);
  };

  const onShowSizeChange = (current, pageSize) => {
    console.log("checkingonsizechange", current, pageSize);
    isChangingPageSizeRef.current = true;
    setCurrent(1);
    setPageCount(pageSize);
    updateQueryParams(1, pageSize);

    handlePaginationChange(1, pageSize);

    setTimeout(() => {
      isChangingPageSizeRef.current = false;
    }, 0);
  };
  useEffect(() => {
    if (isPageChangeTriggered) {
      handlePaginationChange(current, pageCount);
      updateQueryParams(current, pageCount);
      setIsPageChangeTriggered(false);
    }
  }, [isPageChangeTriggered]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [MM, DD, YYYY] = dateStr.split("/");
    return `${YYYY}-${MM}-${DD}`;
  };
  const handlePaginationChange = useCallback(
    (current, pageCount) => {
      const freshLocalData = JSON.parse(
        localStorage.getItem("unsolicitedMassFilterData")
      );
      const hasActiveFilters =
        freshLocalData &&
        ((freshLocalData.searchFilter &&
          freshLocalData.searchFilter !== null) ||
          (freshLocalData.vendorFilter && freshLocalData.vendorFilter !== "") ||
          (freshLocalData.colorFilter && freshLocalData.colorFilter !== "") ||
          (freshLocalData.referenceFilter &&
            freshLocalData.referenceFilter !== "") ||
          (freshLocalData.receivedFilter &&
            freshLocalData.receivedFilter !== "") ||
          (freshLocalData.sizeFilter && freshLocalData.sizeFilter !== ""));

      if (hasActiveFilters) {
        dispatch(
          unsolicitedMassFilter(
            freshLocalData.searchFilter,
            freshLocalData.vendorFilter,
            freshLocalData.colorFilter,
            freshLocalData?.referenceFilter,
            freshLocalData?.receivedFilter,
            freshLocalData.sizeFilter,
            current,
            pageCount
          )
        );
      } else {
        dispatch(getSrtUnsolicitedSamplesList(current, pageCount));
      }
    },
    [current, pageCount]
  );
  return (
    <div>
      {srtSearchLoader ? (
        <Loader />
      ) : null}

      <div className="unsolicited-table">
        <Table
          rowSelection={rowSelection}
          columns={columns}
          // dataSource={data.length ? data : []}
           dataSource={data.slice(0, visibleCount)}
          pagination={false}
          rowClassName="row"
        />
        {isChunkLoading && (
          <BeatLoader
            color={"#0C3D5E"}
            loading={isChunkLoading}
            cssOverride={{
              margin: "30px auto",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              borderColor: "#0C3D5E",
            }}
            size={10}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        )}
      </div>
        <Pagination
          current={current}
          onChange={onChange}
          total={getTotalCount()}
          pageSize={pageCount}
          showSizeChanger = {false}
          // onShowSizeChange={onShowSizeChange}
          style={{ textAlign: "right", marginTop: "20px" }}
        />
    </div>
  );
};

export default UnsolicitedTable;
